<!-- A loading overlay that shows skeleton loaders -->
<template>
  <div class="loading-overlay">
    <div class="loading-overlay__content">
      <div class="loading-overlay__skeletons">
        <skeleton-loader 
          v-for="i in 3" 
          :key="i"
          type="rectangle"
          height="60px"
          class="loading-overlay__skeleton"
        />
      </div>
      <div class="loading-overlay__text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SkeletonLoader from './SkeletonLoader.vue'

export default defineComponent({
  name: 'LoadingOverlay',
  components: {
    SkeletonLoader
  },
  props: {
    text: {
      type: String,
      default: 'Laster...'
    }
  }
})
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  &__content {
    max-width: 400px;
    width: 100%;
    padding: 20px;
  }

  &__skeletons {
    margin-bottom: 20px;
  }

  &__skeleton {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__text {
    text-align: center;
    font-size: 16px;
    color: #666;
  }
}
</style>
